module.exports = __webpack_public_path__ + "static/media/TSHARE.1e424672.svg";